import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Page from '@common/components/Page';
import OnboardingLandingPage from '@rental-manager/pages/Onboarding/LandingPage';
import SinglePropertyDashboard from '@rental-manager/pages/Dashboard/SinglePropertyDashboard';
import { PROPERTY_STATUS } from '@rental-manager/constants/OnboardingConstants';
import DashboardModalRoutes from '@rental-manager/pages//Dashboard/routes';
import OnboardingModalRoutes from '@rental-manager/pages//Onboarding/routes';
import REQUEST_STATUS from '@common/constants/requestStatus';
import userPersonas from '@common/constants/userPersonas';
import Skeleton from '@rental-manager/components/Skeleton';
import queryString from 'query-string';
import './index.scss';
import { IClusterSettingsModel, IConfigModel, ILocationModel } from '@rental-manager/models/Types';

interface Props {
  baseUrl: string;
  listing: { [key: string]: any };
  location: ILocationModel;
  propertyId: string;
  propertyStore: { [key: string]: any };
  onboarding: { [key: string]: any };
  config: IConfigModel;
  clusterSettings: IClusterSettingsModel;
}
class HomePage extends React.Component<Props> {
  renderSuccess = (): React.ReactNode => {
    const { baseUrl, listing, propertyId, onboarding, propertyStore, config, clusterSettings, location } = this.props;

    const searchString = location.search;
    const queryParams = queryString.parse(searchString);
    const collectMoveInCosts = queryParams.collectMoveInCosts === 'true';
    const acceptTerms = onboarding[propertyId]?.acceptTerms || queryParams.acceptTerms === 'true';
    const currentTerm = propertyStore?.currentTerm || {};
    const nextTerm = propertyStore?.nextTerm || {};
    const landlordStatus = propertyStore?.landlordStatus || '';
    const termEnded = propertyStore?.currentTerm?.termEnded || false;
    const propertyStatus = propertyStore?.currentTerm?.propertyStatus || '';
    const nextTermPropertyStatus = propertyStore?.nextTerm?.propertyStatus || '';
    const canCreateOneTimePaymentRequest =
      currentTerm.canCreateOneTimePaymentRequest || nextTerm.canCreateOneTimePaymentRequest;

    if (termEnded || propertyStatus === PROPERTY_STATUS.TENANT_INFO_SET) {
      return (
        <>
          <SinglePropertyDashboard
            baseUrl={baseUrl}
            listing={listing}
            propertyId={propertyId}
            landlordStatus={landlordStatus}
            config={config}
            clusterSettings={clusterSettings}
          />
          <DashboardModalRoutes
            baseUrl={baseUrl}
            listing={listing}
            propertyId={propertyId}
            landlordStatus={landlordStatus}
            config={config}
            clusterSettings={clusterSettings}
            showTermEndedRoutes={termEnded}
            canCreateOneTimePaymentRequest={canCreateOneTimePaymentRequest}
            nextTermPropertyStatus={nextTermPropertyStatus}
          />
        </>
      );
    }

    return (
      <>
        <OnboardingLandingPage
          baseUrl={baseUrl}
          listing={listing}
          propertyId={propertyId}
          propertyStatus={propertyStatus}
          config={config}
          collectMoveInCosts={collectMoveInCosts}
        />
        <OnboardingModalRoutes
          baseUrl={baseUrl}
          listing={listing}
          propertyId={propertyId}
          acceptTerms={acceptTerms}
          landlordStatus={landlordStatus}
          config={config}
          clusterSettings={clusterSettings}
        />
      </>
    );
  };

  renderFail(): React.ReactNode {
    return (
      <Page persona={userPersonas.LANDLORD}>
        <div className="pal">
          <Text>
            Could not load page.&nbsp;
            <Link type="primary" to="/rental-manager" reactRouterLink={ReactRouterLink}>
              Return to rental manager
            </Link>
          </Text>
        </div>
      </Page>
    );
  }

  renderSkeleton = (): React.ReactNode => <Skeleton />;

  render(): React.ReactNode {
    const { propertyStore } = this.props;
    const { requestStatus } = propertyStore;

    if (requestStatus === REQUEST_STATUS.SUCCESS) {
      return this.renderSuccess();
    }

    if (requestStatus === REQUEST_STATUS.FAIL) {
      return this.renderFail();
    }

    return this.renderSkeleton();
  }
}

export default HomePage;
